import {
  TILE_PARTNER_ID,
  PETPAL_PARTNER_ID,
  SHIPRUSH_PARTNER_ID,
  ETRAVELI_PARTNER_ID,
  GENERALI_UNDERWRITER_NAME,
} from '@whitelabel/xcover-shared/helpers/constants';
import messages from './messages';

// eslint-disable-next-line import/prefer-default-export
export const getHeaderMessageKey = (partnerId: any, policyUnderwriterName: string) => {
  if (policyUnderwriterName === GENERALI_UNDERWRITER_NAME) {
    return messages.deductibleHeader;
  }
  switch (partnerId) {
    case TILE_PARTNER_ID:
    case SHIPRUSH_PARTNER_ID:
    case ETRAVELI_PARTNER_ID:
      return messages.deductibleHeader;
    case PETPAL_PARTNER_ID:
      return messages.deductionsHeader;
    default:
      return messages.excessHeader;
  }
};
